// https://apithescope.drytechresto.com/
export const urlApi = 'https://api.thexactscope.com'

export const config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  withCredentials: true
}
